import React, { FC } from "react";

import { ReactComponent as NoFoundImg } from "../../assets/illustrations/404-240x240.svg";
import ServicesLayout from "../../layouts/Services.layout";
import { Button } from "../common";
import { ROUTES } from "../../routes";
import { captureError } from "../../utils/errorMonitoring";

type Props = {
  error?: any;
};

export const ErrorFallback: FC<Props> = ({ error }) => {
  const reload = () => window.location.reload();
  const goHome = () => (window.location.href = ROUTES.HOME);

  captureError(error);

  const message =
    typeof error === "string"
      ? error
      : "error" in error && typeof error["error"] === "string"
        ? (error["error"] as string)
        : "message" in error && typeof error["message"] === "string"
          ? (error["message"] as string)
          : undefined;

  return (
    <ServicesLayout image={<NoFoundImg />} title="Unexpected Error">
      <div className="flex flex-col gap-6">
        <div className="text-lg theme-text-secondary font-semibold">
          We are sorry about this.
        </div>

        {message && <div className="text-base">{message}</div>}

        <div className="flex gap-4 justify-center">
          <Button onClick={reload}>Reload</Button>
          <Button onClick={goHome}>Go home</Button>
        </div>
      </div>
    </ServicesLayout>
  );
};
